/**
 * The placeholder shown while a route's chunk is fetched.
 *
 * Shaped like a real page — header rule, a stat row, a content block — so the
 * layout does not jump when the page arrives. A spinner in the middle of an
 * empty screen would be honest but would also make every navigation feel like
 * a page load, which is exactly the impression a fast tool must avoid.
 */
import { Card, Skeleton, SkeletonRows } from './ui';

export function PageSkeleton() {
  return (
    <div className="content" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading page…</span>
      <div className="page-header">
        <div className="grow stack gap-3">
          <Skeleton variant="chip" width={92} height={11} />
          <Skeleton variant="title" width={260} height={26} />
          <Skeleton width="46%" />
        </div>
      </div>
      <div className="grid cols-3 mb-6">
        {[0, 1, 2].map((i) => (
          <Card key={i} pad>
            <Skeleton width={72} height={30} />
            <Skeleton width={110} height={10} className="mt-3" />
          </Card>
        ))}
      </div>
      <Card pad>
        <SkeletonRows rows={6} />
      </Card>
    </div>
  );
}
